import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getDefaultName } from 'automation-ui-formula-editor/data-sources/DataSourceName';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipEnrolledObject = ({
  dataSourceDefinition,
  dataSourceProperty
}) => {
  const {
    label: dataSourceDisplayLabel,
    name
  } = dataSourceDefinition;
  const {
    label: propertyDisplayLabel
  } = dataSourceProperty;
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "automation-ui-formula-editor.data-passing-panel.single-value-input.tooltip.enrolled_object_jsx",
    options: {
      propertyDisplayLabel
    },
    elements: {
      DataSourceName: () => dataSourceDisplayLabel || getDefaultName(name),
      Bold: 'b'
    }
  });
};
export default TooltipEnrolledObject;